import { Box, Button, Center, Heading, Spacer } from '@chakra-ui/react'
import { EventCalendar } from '@src/components/sco/Events/EventCalendar'
import {
  matchingSignupNavItems,
  MatchingSignupNav,
} from '@src/components/sco/Matching/Layout/MatchingSignupNav'
import { OnboardingLayout } from '@src/components/sco/Onboarding/Layout/OnboardingLayout'
import { OnboardingMainPanel } from '@src/components/sco/Onboarding/Layout/OnboardingMainPanel'
import { OnboardingQuickLinks } from '@src/components/sco/Onboarding/OnboardingQuickLinks'
import { NextLink } from '@src/components/sco/utilities/NextLink'
import React, { useState } from 'react'

export default function Page() {
  const [submitTrigger, setSubmitTrigger] = useState(0)

  return (
    <OnboardingLayout
      navItems={matchingSignupNavItems}
      navPanel={<MatchingSignupNav />}
      mainPanel={
        <OnboardingMainPanel hideNav={true}>
          <Box minHeight={'85vh'} paddingY={'2em'}>
            <Box marginX={'auto'} maxWidth={'1400px'} padding={'1em'} width={'full'}>
              <Heading marginBottom={'1em'}>Where would you like to start?</Heading>
              <OnboardingQuickLinks />

              <Spacer height={'3em'} />

              <Heading marginBottom={'1em'}>Join an Upcoming Event</Heading>
              <EventCalendar defaultWeekCount={1} />

              <Center padding={'1em'}>
                <Button asChild variant={'outline'}>
                  <NextLink href={'/events'} prefetch={false}>
                    View All Events
                  </NextLink>
                </Button>
              </Center>
            </Box>
          </Box>
        </OnboardingMainPanel>
      }
    />
  )
}
